import FilterDetails from './FilterDetails';

export * from './FilterDetails';

export default FilterDetails;
